module.exports = __webpack_public_path__ + "f683e6bb028a9d1a7576439d957589bb.svg";